"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSceneSourceMuteStatus;
var _Sources = require("@studio/constants/Sources");
var _getSources = require("@studio/sources/getSources");
function getSceneSourceMuteStatus(sources, layers, attendeeMuteStatus) {
  var sceneAudioPresenters = layers.reduce(function (acc, layer) {
    if (layer.source.type === _Sources.AUDIO_PRESENTER) {
      acc.push(layer.source.value);
    }
    return acc;
  }, []);

  /** For each of the camera presenter sources,
   * check the audio presenters in layers,
   * and call setDesiredAttendeeMicStatus to unmute
   * them if they exist or mute them if they dont
   */

  var sourcesMuteStatus = sources.reduce(function (acc, source) {
    if (source.type === _Sources.CAMERA_PRESENTER) {
      var sourceValue = (0, _getSources.getSourceValue)(source);
      acc[sourceValue] = !sceneAudioPresenters.includes(source._id);
    }
    return acc;
  }, {});

  // Merge together
  var result = {};

  // Set the values based on attendeeMuteStatus, defaulting to true
  for (var key in attendeeMuteStatus) {
    result[key] = true;
  }

  // Override the values for the keys in sourcesMuteStatus that are false
  for (var _key in sourcesMuteStatus) {
    if (sourcesMuteStatus[_key] === false) {
      result[_key] = false;
    }
  }
  return result;
}